import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateCategoryInput } from '../../../actions/SearchParameter.Actions';
import MultiChipInput from '../../../components/MultiChipInput';

class ObjectCategoryField extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateCategoryInput = this.handleUpdateCategoryInput.bind(this);
  }

  handleUpdateCategoryInput({ results }) {
    const { dispatch } = this.props;
    dispatch(updateCategoryInput(results));
  }

  render() {
    const { category: { available, input } } = this.props;

    return (
      <MultiChipInput
        label="Search by Object Categories"
        data={available}
        bindInput={input}
        onChipDelete={this.handleUpdateCategoryInput}
        onChipCreate={this.handleUpdateCategoryInput}
        onSelectAll={this.handleUpdateCategoryInput}
        onDeleteAll={this.handleUpdateCategoryInput}
      />
    );
  }
}

ObjectCategoryField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  category: PropTypes.shape({
    available: PropTypes.arrayOf(PropTypes.string).isRequired,
    input: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};

function mapStateToProps({ SearchParameter: { category } }) {
  return { category };
}

export default connect(mapStateToProps)(ObjectCategoryField);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/ObjectCategoryField.jsx